// Finding the help page for where somebody is (docs/19). This app keeps where you are in state, not in the address, so
// a page is found by what `reports/onScreen.ts` knows: the tab, and inside the Studio, the step.
import { HELP_PAGES } from "./pages.js";
import type { HelpPage, HelpWhere } from "./types.js";

/** The page about exactly this tab, step or panel. */
export function pageAt(where: HelpWhere): HelpPage | null {
  return HELP_PAGES.find((p) => p.where === where) ?? null;
}

/** The page for the screen in front of somebody: the Studio's step when it has a page of its own, else the tab's. */
export function pageForScreen(on: { screen: string | null; step?: string | null | undefined }): HelpPage | null {
  if (!on.screen) return null;
  if (on.screen === "Studio" && on.step) {
    const step = HELP_PAGES.find((p) => p.where === `step:${on.step}`);
    if (step) return step;
  }
  return HELP_PAGES.find((p) => p.where === `tab:${on.screen}`) ?? null;
}

export function helpPage(slug: string): HelpPage | null {
  return HELP_PAGES.find((p) => p.slug === slug) ?? null;
}
